(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4135],{

/***/ 37004:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/step/checkout/[id]",
      function () {
        return __webpack_require__(20723);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7174:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
var axios = __webpack_require__(97218);
const getCountryAndIp = async ()=>{
    try {
        let { data  } = await axios({
            url: "https://ipapi.co/json",
            method: "get"
        });
        return {
            type: "2",
            data: data
        };
    } catch (error2) {
        try {
            let { data: data1  } = await axios({
                url: "https://api.ip.sb/geoip?callback=",
                method: "get"
            });
            return {
                type: "1",
                data: data1
            };
        } catch (error1) {
            try {
                let { data: data2  } = await axios({
                    url: "https://ipinfo.io",
                    method: "get",
                    headers: {
                        Host: "ipinfo.io",
                        "User-Agent": "curl/7.83.1"
                    }
                });
                return {
                    type: "3",
                    data: data2
                };
            } catch (error) {
                return {
                    type: "500"
                };
            }
        }
    }
};
const countryAndIp = async ()=>{
    let obj = {
        ip: "209.141.54.129",
        country: "US",
        region: "Nevada",
        city: "Las Vegas",
        country_name: "United States"
    };
    try {
        let localCountryAndIp = localStorage.getItem("localCountryAndIp");
        if (localCountryAndIp != null) {
            return JSON.parse(localCountryAndIp);
        }
        let res = await getCountryAndIp();
        if (res.type == "1") {
            obj.ip = res.data.ip;
            obj.country = res.data.country_code;
            obj.region = res.data.country;
            obj.city = res.data.country;
            obj.country_name = res.data.country;
        } else if (res.type == "2") {
            obj.ip = res.data.ip;
            obj.country = res.data.country;
            obj.region = res.data.region != null ? res.data.region : res.data.city;
            obj.city = res.data.city;
            obj.country_name = res.data.country_name;
        } else if (res.type == "3") {
            obj.ip = res.data.ip;
            obj.country = res.data.country;
            obj.region = res.data.region;
            obj.city = res.data.city;
            obj.country_name = res.data.country;
        }
        if (res.type != "500") {
            localStorage.setItem("localCountryAndIp", JSON.stringify(obj));
        }
        return obj;
    } catch (error) {
        return obj;
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (countryAndIp);


/***/ }),

/***/ 20723:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _iconify_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1954);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(57381);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(60770);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _mui_material_Backdrop__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(84808);
/* harmony import */ var _mui_material_CircularProgress__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(98456);
/* harmony import */ var src_lib_getCountryAndIp__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7174);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(5616);
/* harmony import */ var _mui_material_Alert__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(46901);
/* harmony import */ var _mui_material_IconButton__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(93946);
/* harmony import */ var _mui_material_Collapse__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(57922);
/* harmony import */ var _mui_icons_material_Close__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(50594);
/* harmony import */ var styles_checkout_module_scss__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(89937);
/* harmony import */ var styles_checkout_module_scss__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(styles_checkout_module_scss__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(61906);
/* harmony import */ var src_utils_navigate__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(48551);





















const countries = [
    {
        code: "AD",
        label: "Andorra",
        phone: "376"
    },
    {
        code: "AF",
        label: "Afghanistan",
        phone: "93"
    },
    {
        code: "AG",
        label: "Antigua and Barbuda",
        phone: "1-268"
    },
    {
        code: "AI",
        label: "Anguilla",
        phone: "1-264"
    },
    {
        code: "DZ",
        label: "Algeria",
        phone: "213"
    },
    {
        code: "AL",
        label: "Albania",
        phone: "355"
    },
    {
        code: "AM",
        label: "Armenia",
        phone: "374"
    },
    {
        code: "AO",
        label: "Angola",
        phone: "244"
    },
    {
        code: "AQ",
        label: "Antarctica",
        phone: "672"
    },
    {
        code: "AR",
        label: "Argentina",
        phone: "54"
    },
    {
        code: "AS",
        label: "American Samoa",
        phone: "1-684"
    },
    {
        code: "AT",
        label: "Austria",
        phone: "43"
    },
    {
        code: "AU",
        label: "Australia",
        phone: "61",
        suggested: true
    },
    {
        code: "AW",
        label: "Aruba",
        phone: "297"
    },
    {
        code: "AX",
        label: "Alland Islands",
        phone: "358"
    },
    {
        code: "AZ",
        label: "Azerbaijan",
        phone: "994"
    },
    {
        code: "BA",
        label: "Bosnia and Herzegovina",
        phone: "387"
    },
    {
        code: "BB",
        label: "Barbados",
        phone: "1-246"
    },
    {
        code: "BD",
        label: "Bangladesh",
        phone: "880"
    },
    {
        code: "BE",
        label: "Belgium",
        phone: "32"
    },
    {
        code: "BF",
        label: "Burkina Faso",
        phone: "226"
    },
    {
        code: "BG",
        label: "Bulgaria",
        phone: "359"
    },
    {
        code: "BH",
        label: "Bahrain",
        phone: "973"
    },
    {
        code: "BI",
        label: "Burundi",
        phone: "257"
    },
    {
        code: "BJ",
        label: "Benin",
        phone: "229"
    },
    {
        code: "BM",
        label: "Bermuda",
        phone: "1-441"
    },
    {
        code: "BN",
        label: "Brunei Darussalam",
        phone: "673"
    },
    {
        code: "BO",
        label: "Bolivia",
        phone: "591"
    },
    {
        code: "BR",
        label: "Brazil",
        phone: "55"
    },
    {
        code: "BS",
        label: "Bahamas",
        phone: "1-242"
    },
    {
        code: "BT",
        label: "Bhutan",
        phone: "975"
    },
    {
        code: "BV",
        label: "Bouvet Island",
        phone: "47"
    },
    {
        code: "BW",
        label: "Botswana",
        phone: "267"
    },
    {
        code: "BY",
        label: "Belarus",
        phone: "375"
    },
    {
        code: "BZ",
        label: "Belize",
        phone: "501"
    },
    {
        code: "VG",
        label: "British Virgin Islands",
        phone: "1-284"
    },
    {
        code: "IO",
        label: "British Indian Ocean Territory",
        phone: "246"
    },
    {
        code: "CA",
        label: "Canada",
        phone: "1",
        suggested: true
    },
    {
        code: "CC",
        label: "Cocos (Keeling) Islands",
        phone: "61"
    },
    {
        code: "CD",
        label: "Congo, Democratic Republic of the",
        phone: "243"
    },
    {
        code: "CF",
        label: "Central African Republic",
        phone: "236"
    },
    {
        code: "CG",
        label: "Congo, Republic of the",
        phone: "242"
    },
    {
        code: "CI",
        label: "Cote d'Ivoire",
        phone: "225"
    },
    {
        code: "CK",
        label: "Cook Islands",
        phone: "682"
    },
    {
        code: "CL",
        label: "Chile",
        phone: "56"
    },
    {
        code: "CM",
        label: "Cameroon",
        phone: "237"
    },
    {
        code: "CN",
        label: "China",
        phone: "86"
    },
    {
        code: "CO",
        label: "Colombia",
        phone: "57"
    },
    {
        code: "CR",
        label: "Costa Rica",
        phone: "506"
    },
    {
        code: "CU",
        label: "Cuba",
        phone: "53"
    },
    {
        code: "CV",
        label: "Cape Verde",
        phone: "238"
    },
    {
        code: "CW",
        label: "Curacao",
        phone: "599"
    },
    {
        code: "CX",
        label: "Christmas Island",
        phone: "61"
    },
    {
        code: "CY",
        label: "Cyprus",
        phone: "357"
    },
    {
        code: "CZ",
        label: "Czech Republic",
        phone: "420"
    },
    {
        code: "HR",
        label: "Croatia",
        phone: "385"
    },
    {
        code: "KH",
        label: "Cambodia",
        phone: "855"
    },
    {
        code: "KY",
        label: "Cayman Islands",
        phone: "1-345"
    },
    {
        code: "KM",
        label: "Comoros",
        phone: "269"
    },
    {
        code: "TD",
        label: "Chad",
        phone: "235"
    },
    {
        code: "DE",
        label: "Germany",
        phone: "49",
        suggested: true
    },
    {
        code: "DJ",
        label: "Djibouti",
        phone: "253"
    },
    {
        code: "DK",
        label: "Denmark",
        phone: "45"
    },
    {
        code: "DM",
        label: "Dominica",
        phone: "1-767"
    },
    {
        code: "DO",
        label: "Dominican Republic",
        phone: "1-809"
    },
    {
        code: "EC",
        label: "Ecuador",
        phone: "593"
    },
    {
        code: "EE",
        label: "Estonia",
        phone: "372"
    },
    {
        code: "EG",
        label: "Egypt",
        phone: "20"
    },
    {
        code: "GQ",
        label: "Equatorial Guinea",
        phone: "240"
    },
    {
        code: "ER",
        label: "Eritrea",
        phone: "291"
    },
    {
        code: "ET",
        label: "Ethiopia",
        phone: "251"
    },
    {
        code: "SV",
        label: "El Salvador",
        phone: "503"
    },
    {
        code: "FI",
        label: "Finland",
        phone: "358"
    },
    {
        code: "FJ",
        label: "Fiji",
        phone: "679"
    },
    {
        code: "GF",
        label: "French Guiana",
        phone: "594"
    },
    {
        code: "PF",
        label: "French Polynesia",
        phone: "689"
    },
    {
        code: "TF",
        label: "French Southern Territories",
        phone: "262"
    },
    {
        code: "FK",
        label: "Falkland Islands (Malvinas)",
        phone: "500"
    },
    {
        code: "FO",
        label: "Faroe Islands",
        phone: "298"
    },
    {
        code: "FR",
        label: "France",
        phone: "33",
        suggested: true
    },
    {
        code: "GA",
        label: "Gabon",
        phone: "241"
    },
    {
        code: "GD",
        label: "Grenada",
        phone: "1-473"
    },
    {
        code: "GE",
        label: "Georgia",
        phone: "995"
    },
    {
        code: "GG",
        label: "Guernsey",
        phone: "44"
    },
    {
        code: "GH",
        label: "Ghana",
        phone: "233"
    },
    {
        code: "GI",
        label: "Gibraltar",
        phone: "350"
    },
    {
        code: "GL",
        label: "Greenland",
        phone: "299"
    },
    {
        code: "GM",
        label: "Gambia",
        phone: "220"
    },
    {
        code: "GN",
        label: "Guinea",
        phone: "224"
    },
    {
        code: "GP",
        label: "Guadeloupe",
        phone: "590"
    },
    {
        code: "GR",
        label: "Greece",
        phone: "30"
    },
    {
        code: "GT",
        label: "Guatemala",
        phone: "502"
    },
    {
        code: "GU",
        label: "Guam",
        phone: "1-671"
    },
    {
        code: "GW",
        label: "Guinea-Bissau",
        phone: "245"
    },
    {
        code: "GY",
        label: "Guyana",
        phone: "592"
    },
    {
        code: "HM",
        label: "Heard Island and McDonald Islands",
        phone: "672"
    },
    {
        code: "VA",
        label: "Holy See (Vatican City State)",
        phone: "379"
    },
    {
        code: "HN",
        label: "Honduras",
        phone: "504"
    },
    {
        code: "HT",
        label: "Haiti",
        phone: "509"
    },
    {
        code: "HU",
        label: "Hungary",
        phone: "36"
    },
    {
        code: "HK",
        label: "Hong Kong",
        phone: "852"
    },
    {
        code: "ID",
        label: "Indonesia",
        phone: "62"
    },
    {
        code: "IE",
        label: "Ireland",
        phone: "353"
    },
    {
        code: "IL",
        label: "Israel",
        phone: "972"
    },
    {
        code: "IM",
        label: "Isle of Man",
        phone: "44"
    },
    {
        code: "IN",
        label: "India",
        phone: "91"
    },
    {
        code: "IQ",
        label: "Iraq",
        phone: "964"
    },
    {
        code: "IR",
        label: "Iran, Islamic Republic of",
        phone: "98"
    },
    {
        code: "IS",
        label: "Iceland",
        phone: "354"
    },
    {
        code: "IT",
        label: "Italy",
        phone: "39"
    },
    {
        code: "JE",
        label: "Jersey",
        phone: "44"
    },
    {
        code: "JM",
        label: "Jamaica",
        phone: "1-876"
    },
    {
        code: "JO",
        label: "Jordan",
        phone: "962"
    },
    {
        code: "JP",
        label: "Japan",
        phone: "81",
        suggested: true
    },
    {
        code: "KE",
        label: "Kenya",
        phone: "254"
    },
    {
        code: "KG",
        label: "Kyrgyzstan",
        phone: "996"
    },
    {
        code: "KI",
        label: "Kiribati",
        phone: "686"
    },
    {
        code: "KP",
        label: "Korea, Democratic People's Republic of",
        phone: "850"
    },
    {
        code: "KR",
        label: "Korea, Republic of",
        phone: "82"
    },
    {
        code: "KW",
        label: "Kuwait",
        phone: "965"
    },
    {
        code: "KZ",
        label: "Kazakhstan",
        phone: "7"
    },
    {
        code: "XK",
        label: "Kosovo",
        phone: "383"
    },
    {
        code: "LA",
        label: "Lao People's Democratic Republic",
        phone: "856"
    },
    {
        code: "LB",
        label: "Lebanon",
        phone: "961"
    },
    {
        code: "LI",
        label: "Liechtenstein",
        phone: "423"
    },
    {
        code: "LR",
        label: "Liberia",
        phone: "231"
    },
    {
        code: "LS",
        label: "Lesotho",
        phone: "266"
    },
    {
        code: "LT",
        label: "Lithuania",
        phone: "370"
    },
    {
        code: "LU",
        label: "Luxembourg",
        phone: "352"
    },
    {
        code: "LV",
        label: "Latvia",
        phone: "371"
    },
    {
        code: "LY",
        label: "Libya",
        phone: "218"
    },
    {
        code: "MA",
        label: "Morocco",
        phone: "212"
    },
    {
        code: "MC",
        label: "Monaco",
        phone: "377"
    },
    {
        code: "FM",
        label: "Micronesia, Federated States of",
        phone: "691"
    },
    {
        code: "MD",
        label: "Moldova, Republic of",
        phone: "373"
    },
    {
        code: "ME",
        label: "Montenegro",
        phone: "382"
    },
    {
        code: "MG",
        label: "Madagascar",
        phone: "261"
    },
    {
        code: "MH",
        label: "Marshall Islands",
        phone: "692"
    },
    {
        code: "MK",
        label: "Macedonia, the Former Yugoslav Republic of",
        phone: "389"
    },
    {
        code: "ML",
        label: "Mali",
        phone: "223"
    },
    {
        code: "MM",
        label: "Myanmar",
        phone: "95"
    },
    {
        code: "MN",
        label: "Mongolia",
        phone: "976"
    },
    {
        code: "MO",
        label: "Macao",
        phone: "853"
    },
    {
        code: "MQ",
        label: "Martinique",
        phone: "596"
    },
    {
        code: "MR",
        label: "Mauritania",
        phone: "222"
    },
    {
        code: "MS",
        label: "Montserrat",
        phone: "1-664"
    },
    {
        code: "MT",
        label: "Malta",
        phone: "356"
    },
    {
        code: "MU",
        label: "Mauritius",
        phone: "230"
    },
    {
        code: "YT",
        label: "Mayotte",
        phone: "262"
    },
    {
        code: "MV",
        label: "Maldives",
        phone: "960"
    },
    {
        code: "MW",
        label: "Malawi",
        phone: "265"
    },
    {
        code: "MX",
        label: "Mexico",
        phone: "52"
    },
    {
        code: "MY",
        label: "Malaysia",
        phone: "60"
    },
    {
        code: "MZ",
        label: "Mozambique",
        phone: "258"
    },
    {
        code: "NA",
        label: "Namibia",
        phone: "264"
    },
    {
        code: "NC",
        label: "New Caledonia",
        phone: "687"
    },
    {
        code: "NE",
        label: "Niger",
        phone: "227"
    },
    {
        code: "NF",
        label: "Norfolk Island",
        phone: "672"
    },
    {
        code: "NG",
        label: "Nigeria",
        phone: "234"
    },
    {
        code: "NI",
        label: "Nicaragua",
        phone: "505"
    },
    {
        code: "NL",
        label: "Netherlands",
        phone: "31"
    },
    {
        code: "NO",
        label: "Norway",
        phone: "47"
    },
    {
        code: "NP",
        label: "Nepal",
        phone: "977"
    },
    {
        code: "MP",
        label: "Northern Mariana Islands",
        phone: "1-670"
    },
    {
        code: "NR",
        label: "Nauru",
        phone: "674"
    },
    {
        code: "NU",
        label: "Niue",
        phone: "683"
    },
    {
        code: "NZ",
        label: "New Zealand",
        phone: "64"
    },
    {
        code: "OM",
        label: "Oman",
        phone: "968"
    },
    {
        code: "PA",
        label: "Panama",
        phone: "507"
    },
    {
        code: "PE",
        label: "Peru",
        phone: "51"
    },
    {
        code: "PG",
        label: "Papua New Guinea",
        phone: "675"
    },
    {
        code: "PH",
        label: "Philippines",
        phone: "63"
    },
    {
        code: "PK",
        label: "Pakistan",
        phone: "92"
    },
    {
        code: "PL",
        label: "Poland",
        phone: "48"
    },
    {
        code: "PN",
        label: "Pitcairn",
        phone: "870"
    },
    {
        code: "PR",
        label: "Puerto Rico",
        phone: "1"
    },
    {
        code: "PS",
        label: "Palestine, State of",
        phone: "970"
    },
    {
        code: "PT",
        label: "Portugal",
        phone: "351"
    },
    {
        code: "PW",
        label: "Palau",
        phone: "680"
    },
    {
        code: "PY",
        label: "Paraguay",
        phone: "595"
    },
    {
        code: "QA",
        label: "Qatar",
        phone: "974"
    },
    {
        code: "RE",
        label: "Reunion",
        phone: "262"
    },
    {
        code: "RO",
        label: "Romania",
        phone: "40"
    },
    {
        code: "RU",
        label: "Russian Federation",
        phone: "7"
    },
    {
        code: "RW",
        label: "Rwanda",
        phone: "250"
    },
    {
        code: "RS",
        label: "Serbia",
        phone: "381"
    },
    {
        code: "SA",
        label: "Saudi Arabia",
        phone: "966"
    },
    {
        code: "SB",
        label: "Solomon Islands",
        phone: "677"
    },
    {
        code: "GS",
        label: "South Georgia and the South Sandwich Islands",
        phone: "500"
    },
    {
        code: "SC",
        label: "Seychelles",
        phone: "248"
    },
    {
        code: "SD",
        label: "Sudan",
        phone: "249"
    },
    {
        code: "SE",
        label: "Sweden",
        phone: "46"
    },
    {
        code: "SG",
        label: "Singapore",
        phone: "65"
    },
    {
        code: "SH",
        label: "Saint Helena",
        phone: "290"
    },
    {
        code: "SI",
        label: "Slovenia",
        phone: "386"
    },
    {
        code: "BL",
        label: "Saint Barthelemy",
        phone: "590"
    },
    {
        code: "LK",
        label: "Sri Lanka",
        phone: "94"
    },
    {
        code: "LC",
        label: "Saint Lucia",
        phone: "1-758"
    },
    {
        code: "CH",
        label: "Switzerland",
        phone: "41"
    },
    {
        code: "ES",
        label: "Spain",
        phone: "34"
    },
    {
        code: "PM",
        label: "Saint Pierre and Miquelon",
        phone: "508"
    },
    {
        code: "MF",
        label: "Saint Martin (French part)",
        phone: "590"
    },
    {
        code: "KN",
        label: "Saint Kitts and Nevis",
        phone: "1-869"
    },
    {
        code: "SJ",
        label: "Svalbard and Jan Mayen",
        phone: "47"
    },
    {
        code: "SK",
        label: "Slovakia",
        phone: "421"
    },
    {
        code: "SL",
        label: "Sierra Leone",
        phone: "232"
    },
    {
        code: "SM",
        label: "San Marino",
        phone: "378"
    },
    {
        code: "SN",
        label: "Senegal",
        phone: "221"
    },
    {
        code: "SO",
        label: "Somalia",
        phone: "252"
    },
    {
        code: "SR",
        label: "Suriname",
        phone: "597"
    },
    {
        code: "SS",
        label: "South Sudan",
        phone: "211"
    },
    {
        code: "ZA",
        label: "South Africa",
        phone: "27"
    },
    {
        code: "VC",
        label: "Saint Vincent and the Grenadines",
        phone: "1-784"
    },
    {
        code: "ST",
        label: "Sao Tome and Principe",
        phone: "239"
    },
    {
        code: "SX",
        label: "Sint Maarten (Dutch part)",
        phone: "1-721"
    },
    {
        code: "SY",
        label: "Syrian Arab Republic",
        phone: "963"
    },
    {
        code: "SZ",
        label: "Swaziland",
        phone: "268"
    },
    {
        code: "WS",
        label: "Samoa",
        phone: "685"
    },
    {
        code: "TC",
        label: "Turks and Caicos Islands",
        phone: "1-649"
    },
    {
        code: "TG",
        label: "Togo",
        phone: "228"
    },
    {
        code: "TH",
        label: "Thailand",
        phone: "66"
    },
    {
        code: "TJ",
        label: "Tajikistan",
        phone: "992"
    },
    {
        code: "TK",
        label: "Tokelau",
        phone: "690"
    },
    {
        code: "TL",
        label: "Timor-Leste",
        phone: "670"
    },
    {
        code: "TM",
        label: "Turkmenistan",
        phone: "993"
    },
    {
        code: "TN",
        label: "Tunisia",
        phone: "216"
    },
    {
        code: "TO",
        label: "Tonga",
        phone: "676"
    },
    {
        code: "TR",
        label: "Turkey",
        phone: "90"
    },
    {
        code: "TT",
        label: "Trinidad and Tobago",
        phone: "1-868"
    },
    {
        code: "TV",
        label: "Tuvalu",
        phone: "688"
    },
    {
        code: "TW",
        label: "Taiwan, Republic of China",
        phone: "886"
    },
    {
        code: "TZ",
        label: "United Republic of Tanzania",
        phone: "255"
    },
    {
        code: "UA",
        label: "Ukraine",
        phone: "380"
    },
    {
        code: "UG",
        label: "Uganda",
        phone: "256"
    },
    {
        code: "US",
        label: "United States",
        phone: "1",
        suggested: true
    },
    {
        code: "VI",
        label: "US Virgin Islands",
        phone: "1-340"
    },
    {
        code: "UY",
        label: "Uruguay",
        phone: "598"
    },
    {
        code: "UZ",
        label: "Uzbekistan",
        phone: "998"
    },
    {
        code: "GB",
        label: "United Kingdom",
        phone: "44"
    },
    {
        code: "AE",
        label: "United Arab Emirates",
        phone: "971"
    },
    {
        code: "VE",
        label: "Venezuela",
        phone: "58"
    },
    {
        code: "VN",
        label: "Vietnam",
        phone: "84"
    },
    {
        code: "VU",
        label: "Vanuatu",
        phone: "678"
    },
    {
        code: "WF",
        label: "Wallis and Futuna",
        phone: "681"
    },
    {
        code: "EH",
        label: "Western Sahara",
        phone: "212"
    },
    {
        code: "YE",
        label: "Yemen",
        phone: "967"
    },
    {
        code: "ZM",
        label: "Zambia",
        phone: "260"
    },
    {
        code: "ZW",
        label: "Zimbabwe",
        phone: "263"
    }
];
function Checkout(Data) {
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_9__/* .useTranslation */ .$G)("commonAndroid");
    const [RenewalTime, setRenewalTime] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)();
    const [DATA, setDATA] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(Data.Data[0].attributes);
    const [promoCode, setpromoCode] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [iconErr, setIconErr] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [price, setPrice] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)();
    const [originalPriceone, setOriginalPriceone] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)();
    const [originalPrice, setOriginalPrice] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)();
    const label = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    const [Renew, setRenew] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true);
    const [ab, setAb] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
    const { query  } = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
    const [token, setToken] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)();
    const [couponsErr, setCouponsErr] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [couponErr, setCouponErr] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [discountVolume, setDiscountVolume] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)();
    const [opens, setOpens] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [open, setOpen] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [errMessage, setErrMessage] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [ac, setAc] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const CodeRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    //优惠码
    const [searchTerm, setSearchTerm] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)();
    const [ipapi, setIpapi] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)();
    //存储输入框值
    const [data, setData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [Country, setCountry] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [zipCode, setZipCode] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    //Email
    const [user, setUser] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const a = async ()=>{
            let ip = await (0,src_lib_getCountryAndIp__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)();
            if (ip.ip === "" || ip.ip === null || ip.ip === undefined) {
                let ip2 = {
                    ip: "172.104.175.14",
                    country: "SG",
                    region: "Singapore",
                    city: "Singapore",
                    country_name: "Singapore",
                    postal: "89119"
                };
                setIpapi(ip2);
                setData(ip2);
                setCountry(ip2.country_name);
                setZipCode(ip2.postal);
            } else {
                setIpapi(ip);
                setData(ip);
                setCountry(ip.country_name);
                setZipCode(ip.postal);
            }
        };
        a();
        const user = JSON.parse(localStorage.getItem("userData"));
        if (user !== null && user !== "undefined") {
            setUser(user.data.email);
        }
    }, [
        query
    ]);
    //月单价
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (DATA.name === "1 Month Plan") {
            setPrice(parseFloat(DATA.renew_price));
            setOriginalPrice(Data.Data[0].attributes.renew_price);
            setOriginalPriceone(Data.Data[0].attributes.renew_price);
        } else if (DATA.name === "3 Months Plan") {
            setPrice(parseInt(parseFloat(DATA.renew_price).toFixed(2) / 3 * 100) / 100);
            setOriginalPrice(Data.Data[0].attributes.renew_price);
            setOriginalPriceone(parseInt(parseFloat(Data.Data[0].attributes.renew_price).toFixed(2) / 3 * 100) / 100);
        } else {
            setPrice(parseInt(parseFloat(DATA.renew_price).toFixed(2) / 12 * 100) / 100);
            setOriginalPrice(Data.Data[0].attributes.renew_price);
            setOriginalPriceone(parseInt(parseFloat(Data.Data[0].attributes.renew_price).toFixed(2) / 12 * 100) / 100);
        }
        //过期时间
        setRenewalTime(dayjs__WEBPACK_IMPORTED_MODULE_5___default()(dayjs__WEBPACK_IMPORTED_MODULE_5___default()().add(DATA.valid_days, "day")).format("YYYY-MM-DD"));
    }, [
        query
    ]);
    /* const [modal, contextHolder] = Modal.useModal(); */ const [isModalOpen, setIsModalOpen] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    //支付失败弹窗
    const [errPayment, setErrPayment] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [Chatopen, setChatopen] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    /* const Chatopens = () => {
    setChatopen(true)
    setErrPayment(false)
  } */ const handlePayment = ()=>{
        setErrPayment(false);
    };
    const showModal = ()=>{
        setIsModalOpen(true);
    };
    const handleCancel = ()=>{
        setIsModalOpen(false);
    };
    //初始卡号框
    let p = {
        formId: "payment-form",
        formWrapperId: "ab-card-element",
        frameId: "PrivateFrame",
        lang: "en",
        needCardList: false,
        autoValidate: true,
        layout: {
            pageMode: "block" // 页面风格模式  inner | block
        }
    };
    // useEffect(() => {
    //   const sessionToken = async () => {
    //     const result = await fetch(`${process.env.NEXT_PUBLIC_BASE_URL}/api/sessionToken`, {
    //       headers: {
    //         'Content-Type': 'application/json'
    //       },
    //       method: 'get'
    //     })
    //     const res = await result.json() //返回数据
    //     setToken(res.sessionToken)
    //     const ab = AsiabillPay(res.sessionToken)
    //     ab.elementInit('payment_steps', p)
    //       .then(res => {
    //         // 初始化成功后，商户可以在此区域执行其他操作。
    //         // 例如，不需要sdk自带的支付方式列表效果时,获取列表内容后可自定义展示效果。
    //         let paymentMethodList = res.data.paymentMethodList
    //         if (paymentMethodList.length > 0) {
    //           // your code
    //         }
    //         /*  console.log("initRES", res)  */
    //       })
    //       .catch(function (err) {
    //         /* console.log("initERR", err)  */
    //       })
    //     setAb(ab)
    //   }
    //   sessionToken()
    // }, [query])
    const ZipCodeHandle = (e)=>{
        setZipCode(e.target.value);
        setData({
            ...data,
            [e.target.name]: e.target.value
        });
    };
    const handleChange = async (e)=>{
        setData({
            ...data,
            [e.target.name]: e.target.value
        });
    };
    //优惠码
    const CodeChange = async (e)=>{
        setCouponsErr(false);
        setIconErr(false);
        setAc(false);
        setSearchTerm(e.target.value);
        setData({
            ...data,
            [e.target.name]: e.target.value
        });
    };
    //验证优惠码
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (searchTerm !== "" && searchTerm !== undefined && searchTerm !== null) {
            const delayDebounceFn = setTimeout(async ()=>{
                const Couponresponse = await fetch("".concat("https://test-ms-service.gbyte.com.cn", "/api/user/coupon"), {
                    method: "post",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        name: searchTerm
                    })
                });
                const Couponres = await Couponresponse.json();
                if (Couponres.data === null) {
                    setCouponErr(true);
                } else {
                    setCouponErr(false);
                    setData({
                        ...data,
                        coupons: Couponres.data.name
                    });
                    setDiscountVolume(Couponres.data.price);
                    setIconErr(true);
                }
            }, 1000);
            return ()=>clearTimeout(delayDebounceFn);
        }
    }, [
        searchTerm,
        query
    ]);
    const onChanges = (e)=>{
        setData({
            ...data,
            [e.target.name]: e.target.value.trim()
        });
        setCountry(e.target.value);
    };
    const emailonChang = (e)=>{
        setUser(e.target.value);
        setData({
            ...data,
            [e.target.name]: e.target.value.trim()
        });
    };
    const verifyForm = ()=>{
        if (typeof data.firstName == "undefined" || data.firstName == "") {
            document.getElementById("card-errors").innerText = "First name is incomplete";
            return true;
        }
        if (typeof data.lastName == "undefined" || data.lastName == "") {
            document.getElementById("card-errors").innerText = "LastName is incomplete";
            return true;
        }
        if (typeof data.zipCode == "undefined" || data.zipCode == "") {
            document.getElementById("card-errors").innerText = "ZipCode is incomplete";
            return true;
        }
        document.getElementById("card-errors").innerText = "";
        return false;
    };
    //购买按钮
    const HanlderSubmit = async ()=>{
        // 表单校验
        if (verifyForm()) return;
        const UserId = query.user_id;
        if (couponErr === false) {
            setOpens(!opens);
            const response = await fetch("".concat("https://test-ms-service.gbyte.com.cn", "/api/payment-customer"), {
                method: "post",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer ".concat(localStorage.getItem("accessToken"))
                },
                body: JSON.stringify({
                    firstName: data.firstName,
                    lastName: data.lastName,
                    email: user,
                    phone: typeof data.phone == "undefined" || data.phone == "" ? "5622440566" : data.phone,
                    renew: true
                })
            });
            const res = await response.json();
            const customerId = res.data.customerId;
            let paymentMethodObj = {
                billingDetail: {
                    address: {
                        city: ipapi.city,
                        country: ipapi.country,
                        line1: "".concat(ipapi.country, " ").concat(ipapi.region, " ").concat(ipapi.city),
                        postalCode: data.zipCode,
                        state: ipapi.region
                    },
                    email: user,
                    firstName: data.firstName,
                    lastName: data.lastName,
                    phone: typeof data.phone == "undefined" || data.phone == "" ? "5622440566" : data.phone
                },
                customerId: customerId
            };
            ab.confirmPaymentMethod({
                apikey: token,
                trnxDetail: paymentMethodObj
            }).then(async (result)=>{
                if (document.getElementById("card-errors").innerText != "") return;
                let r = result;
                if (r.data.code === "0") {
                    let initParams = {
                        user_id: UserId !== undefined ? UserId : "",
                        callbackUrl: "https://test-ms-service.gbyte.com.cn/api/refund-status-callback",
                        firstName: data.firstName,
                        lastName: data.lastName,
                        zipCode: data.zipCode,
                        phone: typeof data.phone == "undefined" || data.phone == "" ? "5622440566" : data.phone,
                        p_id: Data.Data[0].id,
                        whether_to_renew: Renew ? "1" : "0",
                        customerId: r.data.data.customerId,
                        customerPaymentMethodId: r.data.data.customerPaymentMethodId,
                        orderCurrency: "USD",
                        orderNo: "",
                        returnUrl: "".concat("https://test-ms-web.gbyte.com.cn", "/payment/1"),
                        customerIp: ipapi.ip,
                        country: ipapi.country,
                        region: ipapi.region,
                        city: ipapi.city,
                        afghanistan: ipapi.country_name,
                        platform_type: localStorage.getItem("platform") === null ? "none" : localStorage.getItem("platform"),
                        marketValue: DATA.renew_price,
                        productName: DATA.name,
                        email: user,
                        coupons: data.coupons !== "" && data.coupons !== undefined ? data.coupons : "",
                        webSite: "https://test-ms-web.gbyte.com.cn",
                        renew: true
                    };
                    const responses = await fetch("".concat("https://test-ms-service.gbyte.com.cn", "/api/cut-payment"), {
                        method: "post",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer ".concat(localStorage.getItem("accessToken"))
                        },
                        body: JSON.stringify(initParams)
                    });
                    const res = await responses.json();
                    if (res.code === "R0000") {
                        setErrPayment(true);
                        setOpens(false);
                    } else if (res.data.redirectUrl !== null) {
                        router.push("".concat(res.data.redirectUrl));
                        setOpens(false);
                    } else if (res.data.orderStatus === "success") {
                        (0,src_utils_navigate__WEBPACK_IMPORTED_MODULE_10__/* .navigateTo */ .T8)("".concat("https://test-ms-web.gbyte.com.cn", "/payment-success?orderNo=").concat(res.data.orderNo, "&orderAmount=").concat(res.data.orderAmount));
                        setOpens(false);
                    } else {
                        (0,src_utils_navigate__WEBPACK_IMPORTED_MODULE_10__/* .navigateTo */ .T8)("".concat("https://test-ms-web.gbyte.com.cn", "/payment-fail?orderNo=").concat(res.data.orderNo, "&orderAmount=").concat(res.data.orderAmount));
                        setOpens(false);
                    }
                } else {
                    setErrMessage(r.data.message);
                    setOpen(true);
                    setOpens(false);
                }
            });
        } else {
            setAc(true);
            setOpens(false);
        }
    };
    // 本地支付
    const paymentWill = async ()=>{
        let currentUser = JSON.parse(localStorage.getItem("userData"));
        let response = await fetch("".concat("https://strapi.gbyte.ai/api", "/paymentwall"), {
            method: "post",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                p_id: Data.Data[0].id,
                site: "msafely",
                user_id: currentUser.data.id,
                whether_to_renew: Renew ? "1" : "0",
                platform_type: localStorage.getItem("platform") === null ? "Android-Cloud" : localStorage.getItem("platform"),
                renew: true
            })
        });
        const a = await response.json();
        setLocalUrl(a.url);
    };
    const [paypalUrl, setPaypalUrl] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    // paypal
    const Paypal = async ()=>{
        let currentUser = JSON.parse(localStorage.getItem("userData"));
        const response = await fetch("".concat("https://strapi.gbyte.ai/api", "/paymentwall"), {
            method: "post",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                p_id: Data.Data[0].id,
                ps: "paypal",
                site: "msafely",
                user_id: currentUser.data.id,
                whether_to_renew: Renew ? "1" : "0",
                platform_type: localStorage.getItem("platform") === null ? "Android-Cloud" : localStorage.getItem("platform"),
                renew: true
            })
        });
        const a = await response.json();
        setPaypalUrl(a.url);
    };
    // 空中云汇
    const airwallex = async ()=>{
        let currentUser = JSON.parse(localStorage.getItem("userData"));
        const p = DATA.name.replace(/\s*/g, "");
        let whether_to_renew = Renew ? "1" : "0";
        (0,src_utils_navigate__WEBPACK_IMPORTED_MODULE_10__/* .navigateTo */ .T8)("https://gbyte.ai/checkout1/8c88f8cc-0457-40d1?p_id=".concat(Data.Data[0].id, "&site=msafely&user_id=").concat(currentUser.data.id, "&whether_to_renew=").concat(whether_to_renew, "&p=").concat(p, "&email=").concat(currentUser.data.email));
    };
    // 加密货币
    const crypto = async ()=>{
        let currentUser = JSON.parse(localStorage.getItem("userData"));
        let data = {
            email: currentUser.data.email,
            p_id: Data.Data[0].id,
            platform_type: localStorage.getItem("platform") === null ? "none" : localStorage.getItem("platform"),
            renew: true
        };
        const response = await fetch("".concat("https://test-ms-service.gbyte.com.cn", "/api/now-payment"), {
            method: "post",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer ".concat(localStorage.getItem("accessToken"))
            },
            body: JSON.stringify(data)
        });
        const a = await response.json();
        if (a.code === 0) {
            (0,src_utils_navigate__WEBPACK_IMPORTED_MODULE_10__/* .navigateTo */ .T8)(a.data.url);
        }
    };
    const [paymentTypeIndex, setPaymentTypeIndex] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(1);
    const [localUrl, setLocalUrl] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [antiShake, setAntiShake] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    // 点击支付执行当前类型函数
    const typePayNow = async ()=>{
        // 发起支付
        if (paymentTypeIndex === 1) {
            HanlderSubmit();
        } else if (paymentTypeIndex === 2) {
            Paypal();
        } else if (paymentTypeIndex === 3) {
            paymentWill();
        } else if (paymentTypeIndex === 5) {
            crypto();
        }
    };
    // 所有支付类型
    const allPaymentType = [
        {
            id: 1,
            name: t("Credit Debit Card"),
            icon: "/image/checkout/credit-card.png",
            img: [
                "https://msafely.com/images/definition/visa.svg",
                "https://msafely.com/images/definition/mastercard.svg",
                "https://msafely.com/images/definition/discover.svg",
                "https://msafely.com/images/definition/jcb.svg",
                "https://msafely.com/images/definition/american-express.svg",
                "/image/paymentlist/discover.svg",
                "/image/paymentlist/direct-debit.svg"
            ],
            width: "38px",
            left: "-20px"
        }
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "Local-step ".concat(paymentTypeIndex === 1 ? "md:h-full" : "", " bg-[#fff] Sixmd:border-t-[1px] Blds:shadow-step Sixmds:rounded-[10px] pb-[50px] pt-[30px] relative"),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "bg-[#fff]",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "mx-auto Bxl:w-[95%]",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                sx: {
                                    width: "70%"
                                },
                                className: "fixed flex items-center justify-center pt-2 z-50",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Collapse__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                    in: open,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Alert__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                        variant: "outlined",
                                        severity: "error",
                                        action: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_IconButton__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                            "aria-label": "close",
                                            color: "inherit",
                                            size: "small",
                                            onClick: ()=>{
                                                setOpen(false);
                                            },
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Close__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                fontSize: "inherit"
                                            })
                                        }),
                                        sx: {
                                            mb: 2
                                        },
                                        children: errMessage !== "" && errMessage !== undefined ? errMessage : t("Network timeout please try again later")
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex justify-center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "w-[310px] Hsm:hidden absolute left-[10vw] Headers66:left-0 Header6:left-[18vw]",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "w-[105px] ml-[64px] mt-[25px]",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                    src: DATA.img.data.attributes.url,
                                                    width: 100,
                                                    height: 100,
                                                    alt: "photo",
                                                    className: "w-[105px] h-[150px]"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "mt-[23px]",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                                                        className: "text-[20px] text-[#1c1e53] w-[220px] mx-auto",
                                                        children: [
                                                            "Msafely ",
                                                            DATA.name
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                                        className: "text-[#282938] text-[14px] mt-[18px] text-opacity-70 ml-[46px]",
                                                        onClick: showModal,
                                                        children: [
                                                            t("AUTO-RENEWAL"),
                                                            " :",
                                                            Renew ? t("ON") : t("OFF")
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "w-[784px]",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "text-center mx-auto mt-[10px]",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                                        className: "text-[36px] font-[600] Bld:text-[24px] text-[#282938] sm:mt-[6px]",
                                                        children: t("Shopping cart")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "mt-[26px] sm:w-[99%] w-[90%] xs:w-full grid mx-auto justify-center sm:flex pb-[10px]",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "flex divide-dashed text-[14px] mx-auto text-[#333] sm:justify-cente xs:w-[330px] items-center justify-center ".concat(localStorage.getItem("ProductID") !== "3" ? "" : ""),
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                                        className: "text-[14.4px] xs:text-[13px] text-[#333] mr-2",
                                                                        children: [
                                                                            t("SUBSCRIPTION PERIOD"),
                                                                            ":"
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "border-b border-black  sm:w-1/3 mt-4 ".concat(localStorage.getItem("ProductID") !== "3" ? "w-[195px] sm:xs:w-[60px]" : "w-[180px] sm:xs:w-[50px]")
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                        className: "text-[20px] xs:text-[15px] text-[#000] ml-2 ".concat(DATA.name === "1 Month Plan" && "xs:ml-0"),
                                                                        children: DATA.name
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "flex divide-dashed text-[14px] mt-[10px] text-black text-opacity-80 xs:w-[330px] items-center justify-center",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                                        className: "text-[14.4px] xs:text-[13px] text-[#333] mt-1",
                                                                        children: [
                                                                            t("1 MONTH PRICE"),
                                                                            ":"
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "border-t border-black  mt-4 ".concat(localStorage.getItem("ProductID") !== "3" ? "w-[295px] sm:xs:w-[145px]" : "w-[290px] xs:w-[150px]")
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                                        className: "ml-2 text-[20px] xs:text-[15px] text-[#000]",
                                                                        children: [
                                                                            price,
                                                                            " USD"
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: (styles_checkout_module_scss__WEBPACK_IMPORTED_MODULE_16___default().all_payment_box),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "font-[600] pt-2 text-[15px] mb-1",
                                                            children: t("Pick a payment method")
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            style: {
                                                                display: paymentTypeIndex === 3 ? "block" : "none"
                                                            },
                                                            children: t("Different IP shows different payment")
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: (styles_checkout_module_scss__WEBPACK_IMPORTED_MODULE_16___default().paymentIcon),
                                                            children: paymentTypeIndex > 0 ? allPaymentType[paymentTypeIndex - 1].img.map((row, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                                    src: row,
                                                                    alt: "img",
                                                                    width: "32",
                                                                    height: "32",
                                                                    style: {
                                                                        width: allPaymentType[paymentTypeIndex - 1].width,
                                                                        height: "auto"
                                                                    },
                                                                    className: "".concat(row === "https://msafely.com/images/definition/visa.svg" || row === "https://msafely.com/images/definition/mastercard.svg" || row === "https://msafely.com/images/definition/discover.svg" || row === "https://msafely.com/images/definition/jcb.svg" || row === "https://msafely.com/images/definition/american-express.svg" || row === "/image/paymentlist/discover.svg" || row === "/image/paymentlist/direct-debit.svg" || row === "https://msafely.com/images/definition/btc.svg" || row === "https://msafely.com/images/definition/eth.svg" || row === "https://msafely.com/images/definition/usdttrc20.svg" || row === "https://msafely.com/images/definition/bnbbsc.svg" || row === "https://msafely.com/images/definition/ada.svg" || row === "https://msafely.com/images/definition/sol.svg" || row === "https://msafely.com/images/definition/trx.svg" || row === "https://msafely.com/images/definition/avaxc.svg" ? "xs:w-[30px] xs:h-[30px]" : "xs:w-[40px] xs:h-[28px] ")
                                                                }, i)) : null
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                                            className: (styles_checkout_module_scss__WEBPACK_IMPORTED_MODULE_16___default().payment_type),
                                                            children: allPaymentType.map((row)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                                            style: {
                                                                                background: paymentTypeIndex === row.id ? "#DCDCDC" : ""
                                                                            },
                                                                            onClick: ()=>{
                                                                                if (row.id === 3) {
                                                                                    paymentWill();
                                                                                } else if (row.id === 2) {
                                                                                    Paypal();
                                                                                }
                                                                                setPaymentTypeIndex(row.id);
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                                                    src: row.icon,
                                                                                    alt: "icon",
                                                                                    width: "32",
                                                                                    height: "32",
                                                                                    style: {
                                                                                        position: "relative",
                                                                                        left: row.left
                                                                                    }
                                                                                }),
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                    children: row.name
                                                                                })
                                                                            ]
                                                                        }),
                                                                        row.id === 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                            class: "form-wrap",
                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("form", {
                                                                                id: "payment-form",
                                                                                onSubmit: HanlderSubmit,
                                                                                style: {
                                                                                    display: paymentTypeIndex === 1 ? "block" : "none"
                                                                                },
                                                                                className: " pb-[10px]",
                                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                    className: "w-[90%] md:pl-[1px] Sixmd:w-[98%] bg-[#f0f1f2] mx-auto mt-[20px] sm:mt-[20px] rounded-[8px] shadow-4xl relative ",
                                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                        className: " md:w-[100%] bg-[#f0f1f2] rounded-xl shadow-4xl pb-[20px]",
                                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                            className: "w-[92%] mx-auto md:pt-2",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                                    id: "card-errors",
                                                                                                    role: "alert",
                                                                                                    className: "text-center"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                                    id: "ab-card-element",
                                                                                                    class: "ab-element",
                                                                                                    className: ""
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                                    className: "flex pt-1 mx-auto",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                                            className: "w-[50%]",
                                                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                                                                                onChange: handleChange,
                                                                                                                type: "text",
                                                                                                                name: "firstName",
                                                                                                                placeholder: t("First name"),
                                                                                                                required: true,
                                                                                                                className: "mt-1 h-[44px] w-[100%] rounded pl-2 shadow-2xl outline-none placeholder:text-[15px] placeholder:text-[#777474]"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                                            className: "ml-[7px] w-[50%]",
                                                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                                                                                onChange: handleChange,
                                                                                                                type: "text",
                                                                                                                name: "lastName",
                                                                                                                placeholder: t("Last name"),
                                                                                                                required: true,
                                                                                                                className: "mt-1 pl-2 w-[100%] h-[44px] rounded outline-none shadow-2xl placeholder:text-[15px] placeholder:text-[#777474]"
                                                                                                            })
                                                                                                        })
                                                                                                    ]
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                                    className: "flex pt-2 mx-auto",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                                            className: "w-[50%] h-[44px] grid items-center relative bg-[#fff] rounded mt-1",
                                                                                                            children: [
                                                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                                                    className: " absolute top-[4px] left-[8px] text-[12px] text-[#777474] ",
                                                                                                                    children: t("Country Region")
                                                                                                                }),
                                                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("select", {
                                                                                                                    onChange: onChanges,
                                                                                                                    name: "country",
                                                                                                                    value: Country === null || Country === undefined ? "" : Country,
                                                                                                                    className: "w-[93%] h-[px] rounded pl-1 xss:pt-4 xs:text-[13px] text-[14px] outline-none xs:ml-[2px] xs:mt-4 bg-[#fff]",
                                                                                                                    children: countries.map((item, index)=>{
                                                                                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                                                                                            className: "",
                                                                                                                            children: item.label
                                                                                                                        }, index);
                                                                                                                    })
                                                                                                                })
                                                                                                            ]
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                                            className: "w-[50%] ml-[7px]",
                                                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                                                                                type: "zipCode",
                                                                                                                name: "zipCode",
                                                                                                                placeholder: t("Zip Code"),
                                                                                                                required: true,
                                                                                                                value: zipCode === null || zipCode === undefined ? "" : zipCode,
                                                                                                                onChange: ZipCodeHandle,
                                                                                                                className: "mt-1 w-[100%] h-[44px] rounded pl-2 outline-none placeholder:text-[15px] placeholder:text-[#777474]"
                                                                                                            })
                                                                                                        })
                                                                                                    ]
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                                    className: "flex pt-2 mx-auto",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                                            className: "w-[50%]",
                                                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                                                                                name: "email",
                                                                                                                type: "type",
                                                                                                                placeholder: t("Email"),
                                                                                                                value: user === null || user === undefined ? "" : user,
                                                                                                                onChange: emailonChang,
                                                                                                                required: true,
                                                                                                                className: "w-[100%] sm:w-[100%] h-[44px] mt-1 rounded outline-none pl-2 placeholder:text-[15px] placeholder:text-[#777474]"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                                            className: "w-[50%] ml-[7px]",
                                                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                                                                                name: "phone",
                                                                                                                type: "type",
                                                                                                                placeholder: t("Phone optional"),
                                                                                                                onChange: handleChange,
                                                                                                                className: "w-[100%] sm:w-[100%] h-[44px] mt-1 rounded outline-none pl-2 placeholder:text-[15px] placeholder:text-[#777474]"
                                                                                                            })
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    })
                                                                                })
                                                                            })
                                                                        }) : null,
                                                                        row.id === 2 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                            style: {
                                                                                display: paymentTypeIndex === 2 ? "block" : "none"
                                                                            },
                                                                            className: (styles_checkout_module_scss__WEBPACK_IMPORTED_MODULE_16___default().local_payment),
                                                                            children: [
                                                                                paypalUrl == "" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {}) : null,
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
                                                                                    className: (styles_checkout_module_scss__WEBPACK_IMPORTED_MODULE_16___default().iframe),
                                                                                    src: paypalUrl
                                                                                })
                                                                            ]
                                                                        }) : null,
                                                                        row.id === 3 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                            style: {
                                                                                display: paymentTypeIndex === 3 ? "block" : "none"
                                                                            },
                                                                            className: (styles_checkout_module_scss__WEBPACK_IMPORTED_MODULE_16___default().local_payment),
                                                                            children: [
                                                                                localUrl == "" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {}) : null,
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
                                                                                    className: (styles_checkout_module_scss__WEBPACK_IMPORTED_MODULE_16___default().iframe),
                                                                                    src: localUrl
                                                                                })
                                                                            ]
                                                                        }) : null
                                                                    ]
                                                                }, row.id))
                                                        })
                                                    ]
                                                }),
                                                promoCode && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "items-center relative md:hidden",
                                                    style: {
                                                        display: promoCode ? "flex" : "none"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                            onChange: CodeChange,
                                                            ref: CodeRef,
                                                            type: "text",
                                                            name: "coupons",
                                                            placeholder: t("Please Enter Coupon"),
                                                            className: "mt-3 w-[99%] h-[45px] rounded pl-3 outline-none"
                                                        }),
                                                        iconErr && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_iconify_react__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .JO, {
                                                            icon: "icon-park-outline:correct",
                                                            className: "w-[25px] h-[25px] absolute right-0 mt-3 text-green-600 mr-2"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    onClick: ()=>{
                                                        setpromoCode(!promoCode), setAc(false), setIconErr(false), setCouponErr(false), setData({
                                                            ...data,
                                                            coupons: ""
                                                        });
                                                    },
                                                    className: "w-[99%] items-center justify-center mt-[15px] text-[#49BFF3] text-[14px] h-[50px] border border-[#49BFF3] cursor-pointer rounded-md hover:bg-[#e4edf0] uppercase md:hidden",
                                                    style: {
                                                        display: promoCode ? "flex" : "none"
                                                    },
                                                    children: t("I dont have a coupon code")
                                                }),
                                                ac && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "text-red-500 text-center mt-3 text-[15px]",
                                                    children: t("Coupon code is invalid Please check and try again")
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                    style: {
                                                        display: paymentTypeIndex === 3 || paymentTypeIndex === 2 ? "none" : "block",
                                                        height: "50px",
                                                        background: "#50e3c2",
                                                        borderRadius: "30px",
                                                        fontSize: "19px",
                                                        fontWeight: "600"
                                                    },
                                                    className: "w-[450px] Bld:w-[98%] text-black text-opacity-90 mt-[50px] xs:mt-[30px] mx-auto",
                                                    onClick: ()=>typePayNow(),
                                                    children: t("PAY NOW")
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                    className: "text-[14px] font-[600] text-[#333] sm:text-[13px] text-center mt-[30px]",
                                                    style: {
                                                        textDecoration: iconErr && "line-through"
                                                    },
                                                    children: [
                                                        t("YOU WILL PAY"),
                                                        " ",
                                                        parseFloat(DATA.renew_price),
                                                        " USD ",
                                                        t("INSTEAD")
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "mx-auto w-[510px] text-center mt-6 sm:w-11/12",
                                                    children: [
                                                        iconErr && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                            className: "text-center mt-4 text-[14px] text-[#333] sm:text-white sm:text-[13px] uppercase ",
                                                            children: [
                                                                t("Your coupon is valid You only need to pay"),
                                                                " ",
                                                                (parseFloat(DATA.price) + parseFloat(DATA.setup) - parseFloat(discountVolume)).toFixed(2),
                                                                " USD !"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                            className: "text-[12px] mt-8 sm:mt-3 text-[#000000] text-opacity-60 sm:text-opacity-50 sm:text-[12px]",
                                                            children: [
                                                                "*",
                                                                t("The price has been discounted Package includes a one-time installation service fee of 4.99 if you cancel the order the installation service fee is non-refundable")
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                            className: "mt-3 text-[12px] text-black text-opacity-60",
                                                            suppressHydrationWarning: true,
                                                            children: [
                                                                t("Your subscription will be renewed on"),
                                                                " ",
                                                                RenewalTime
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(antd__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                title: "Confirm",
                                open: isModalOpen,
                                onCancel: handleCancel,
                                centered: true,
                                maskClosable: false,
                                className: "CheckoutModal",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                        className: "text-[#333] text-[14px]",
                                        children: [
                                            t("Auto-Renewal Plan is designed to save your time effort and risk By extending your subscription automatically you can prevent service interruption and loss of connection with your monitored device Subscription starts"),
                                            " ",
                                            RenewalTime,
                                            ", ",
                                            t("the renewal price is"),
                                            " $",
                                            DATA.renew_price
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                        className: "flex items-center mt-[10px]",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                type: "checkbox",
                                                defaultChecked: Renew ? "" : "checked",
                                                onClick: ()=>setRenew(!Renew)
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "ml-2",
                                                children: t("Renew manually")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(antd__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                open: errPayment,
                                onCancel: handlePayment,
                                centered: true,
                                maskClosable: false,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "mt-[20px]",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_iconify_react__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .JO, {
                                            icon: "codicon:error",
                                            className: "w-[100px] h-[100px] text-red-500 mx-auto"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: " text-center pt-[20px]",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                className: "font-[600] text-[30px] Sixmd:text-[24px]",
                                                children: t("Transaction has been declined")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                className: "pt-[15px] text-[19px] font-[500] Sixmd:text-[15px]",
                                                children: [
                                                    t("Contact us for assistance"),
                                                    ": ",
                                                    "service@msafely.com"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "flex items-center justify-center pt-[25px]",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                        className: "block border-b-[2px] w-[30%] mr-4"
                                                    }),
                                                    t("OR"),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                        className: "block border-b-[2px] w-[30%] ml-4"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Backdrop__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                    sx: {
                        color: "#fff",
                        zIndex: (theme)=>theme.zIndex.drawer + 1
                    },
                    open: opens,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_CircularProgress__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                        color: "inherit"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    onClick: ()=>router.push("/android/step/pricing"),
                    className: "absolute right-4 top-4",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_iconify_react__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .JO, {
                        icon: "akar-icons:cross",
                        className: "w-[24px] h-[24px] text-black/40"
                    })
                })
            ]
        })
    });
}
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Checkout);


/***/ }),

/***/ 89937:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"all_payment_box":"checkout_all_payment_box__dRA5C","paymentIcon":"checkout_paymentIcon__TfwML","payment_type":"checkout_payment_type__v42EF","li_hover":"checkout_li_hover__2Wj2p","local_payment":"checkout_local_payment___2Vyp","iframe":"checkout_iframe__I8raO"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3498,5675,5432,9830,5170,1954,518,2862,770,2607,210,1664,3138,9774,2888,179], function() { return __webpack_exec__(37004); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);